module.exports = __webpack_public_path__ + "img/9.a15fb271.png";